export const LAYOUT_BREAKPOINT = {
  sm: 370,
  md: 768,
  lg: 1024,
  xl: 1200,
  "2xl": 1400,
} as const;
